<template>
  <div class="wrap" @mousedown="click" @touchstart="click">
    <audio :src="src" controls :id="id" />
  </div>
</template>

<script>
/* eslint-disable no-console */
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import Hashids from 'hashids';

export default {
  name: 'AudioModal',
  props: {
    src: String,
    options: Object,
    mute: Boolean,
    audioid: String,
  },
  data() {
    return {
      player: {},
      id: '',
    };
  },
  created() {},
  mounted() {
    const hashids = new Hashids('me', 8, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ-_');
    console.log(this.audioid);
    const data = new TextEncoder().encode(this.audioid);
    var array = [];
    for (let index = 0; index < data.length; index++) {
      array.push(data[index]);
    }
    console.log(data);
    this.id = hashids.encode(array);
    console.log(this.id);
    const ua = navigator.userAgent;
    const start = ua.indexOf('OS ');
    let iOSver = 999;
    if ((ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) && start > -1) {
      iOSver = parseFloat(ua.substr(start + 3, 3).replace('_', '.'));
      console.log(iOSver);
    }
    this.$nextTick(() => {
      if (iOSver <= 12) {
        this.player = new Plyr(`#${this.id}`, {
          controls: ['play-large', 'play', 'mute', 'volume'],
        });
      } else {
        this.player = new Plyr(`#${this.id}`, {
          controls: [
            'play-large',
            'play',
            'progress',
            'current-time',
            'mute',
            'volume',
          ],
        });
      }
    });

    this.$nextTick(() => {
      this.player.muted = this.mute;
    });
  },
  computed: {},
  beforeDestroy() {
    if (!this.player.paused) {
      this.player.pause();
    }
    this.player.destroy();
  },
  methods: {
    click(e) {
      e.stopPropagation();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
